import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Box, TextField, Typography} from '@mui/material';
import {useFormInput} from '../../utils/utilities';
import {CustomButton, PasswordInput} from '../../components';
import {configureElevator} from '../../actions/elevatorsActions';
import {fieldError, isFieldIvalid} from '../../utils/errorHandler';

const isInvalid = value => {
  if (value !== '' && (+value < 1 || +value > 25)) {
    return true;
  }
  return false;
};

const ConfigurationsForm = ({id, configurations}) => {
  const dispatch = useDispatch();
  const {user} = useSelector(s => s.user);
  const {elevatorsError, elevatorsLoading} = useSelector(s => s.elevators);
  const isSuperAdmin = user && user?.role === 'SUPERADMIN';

  const sms_username = useFormInput(configurations.sms_username || '');
  const sms_password = useFormInput(configurations.sms_password || '');
  const imei = useFormInput(configurations.imei || '');
  const notes = useFormInput(configurations.notes || '');
  const delay1 = useFormInput(configurations.relay1Delay || '');
  const delay2 = useFormInput(configurations.relay2Delay || '');
  const delay3 = useFormInput(configurations.relay3Delay || '');
  const delay4 = useFormInput(configurations.relay4Delay || '');
  const delay5 = useFormInput(configurations.relay5Delay || '');
  const delay6 = useFormInput(configurations.relay6Delay || '');
  const delay7 = useFormInput(configurations.relay7Delay || '');
  const delay8 = useFormInput(configurations.relay8Delay || '');
  const delay9 = useFormInput(configurations.relay9Delay || '');
  const delay10 = useFormInput(configurations.relay10Delay || '');
  const delay11 = useFormInput(configurations.relay11Delay || '');
  const delay12 = useFormInput(configurations.relay12Delay || '');
  const delay13 = useFormInput(configurations.relay13Delay || '');
  const delay14 = useFormInput(configurations.relay14Delay || '');
  const delay15 = useFormInput(configurations.relay15Delay || '');
  const delay16 = useFormInput(configurations.relay16Delay || '');

  const onSave = e => {
    e.preventDefault();
    const values = [
      id,
      imei.value,
      notes.value,
      delay1.value,
      delay2.value,
      delay3.value,
      delay4.value,
      delay5.value,
      delay6.value,
      delay7.value,
      delay8.value,
      delay9.value,
      delay10.value,
      delay11.value,
      delay12.value,
      delay13.value,
      delay13.value,
      delay15.value,
      delay16.value,
    ];
    if (isSuperAdmin) {
      values.push(sms_username.value);
      values.push(sms_password.value);
    }
    dispatch(configureElevator(...values));
  };

  return (
    <form onSubmit={onSave}>
      <Box my="3rem" mx="2rem" display="flex" gap="2rem" position="relative">
        <Box
          height="500px"
          width="40%"
          top="6rem"
          left="2rem"
          position="sticky"
          display="flex"
          flexDirection="column">
          {isSuperAdmin && (
            <>
              <Typography fontSize="14px" fontWeight="600">
                SMS Username:
              </Typography>
              <TextField
                required
                {...sms_username}
                inputProps={{maxlength: 10}}
                error={isFieldIvalid(elevatorsError, 'sms_username')}
                helperText={fieldError(elevatorsError, 'sms_username')}
              />
              <Typography fontSize="14px" fontWeight="600" mt="1.5rem">
                SMS Password:
              </Typography>
              <PasswordInput
                {...sms_password}
                sx={{marginBottom: '1.5rem'}}
                label=""
                inputProps={{maxlength: 10}}
                error={isFieldIvalid(elevatorsError, 'sms_password')}
                helperText={fieldError(elevatorsError, 'sms_password')}
              />
            </>
          )}
          <Typography fontSize="14px" fontWeight="600">
            IMEI:
          </Typography>
          <TextField
            required
            {...imei}
            error={isFieldIvalid(elevatorsError, 'imei')}
            helperText={fieldError(elevatorsError, 'imei')}
          />
          <Typography fontSize="14px" fontWeight="600" mt="1.5rem">
            Notes:
          </Typography>
          <TextField
            minRows="4"
            {...notes}
            multiline
            error={isFieldIvalid(elevatorsError, 'notes')}
            helperText={fieldError(elevatorsError, 'notes')}
          />
          <Box mt="2rem">
            <CustomButton type="submit" loading={elevatorsLoading} fullWidth>
              Save
            </CustomButton>
          </Box>
        </Box>
        <Box flex={1} display="flex" flexDirection="column" gap="1.5rem">
          <TextField
            {...delay1}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay1Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay1.value) ||
              isFieldIvalid(elevatorsError, 'relay1Delay')
            }
            helperText={fieldError(elevatorsError, 'relay1Delay')}
          />
          <TextField
            {...delay2}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay2Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay2.value) ||
              isFieldIvalid(elevatorsError, 'relay2Delay')
            }
            helperText={fieldError(elevatorsError, 'relay2Delay')}
          />
          <TextField
            {...delay3}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay3Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay3.value) ||
              isFieldIvalid(elevatorsError, 'relay3Delay')
            }
            helperText={fieldError(elevatorsError, 'relay3Delay')}
          />
          <TextField
            {...delay4}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay4Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay4.value) ||
              isFieldIvalid(elevatorsError, 'relay4Delay')
            }
            helperText={fieldError(elevatorsError, 'relay4Delay')}
          />
          <TextField
            {...delay5}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay5Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay5.value) ||
              isFieldIvalid(elevatorsError, 'relay5Delay')
            }
            helperText={fieldError(elevatorsError, 'relay5Delay')}
          />
          <TextField
            {...delay6}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay6Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay6.value) ||
              isFieldIvalid(elevatorsError, 'relay6Delay')
            }
            helperText={fieldError(elevatorsError, 'relay6Delay')}
          />
          <TextField
            {...delay7}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay7Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay7.value) ||
              isFieldIvalid(elevatorsError, 'relay7Delay')
            }
            helperText={fieldError(elevatorsError, 'relay7Delay')}
          />
          <TextField
            {...delay8}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay8Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay8.value) ||
              isFieldIvalid(elevatorsError, 'relay8Delay')
            }
            helperText={fieldError(elevatorsError, 'relay8Delay')}
          />
          <TextField
            {...delay9}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay9Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay9.value) ||
              isFieldIvalid(elevatorsError, 'relay9Delay')
            }
            helperText={fieldError(elevatorsError, 'relay9Delay')}
          />
          <TextField
            {...delay10}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay10Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay10.value) ||
              isFieldIvalid(elevatorsError, 'relay10Delay')
            }
            helperText={fieldError(elevatorsError, 'relay10Delay')}
          />
          <TextField
            {...delay11}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay11Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay11.value) ||
              isFieldIvalid(elevatorsError, 'relay11Delay')
            }
            helperText={fieldError(elevatorsError, 'relay11Delay')}
          />
          <TextField
            {...delay12}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay12Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay12.value) ||
              isFieldIvalid(elevatorsError, 'relay12Delay')
            }
            helperText={fieldError(elevatorsError, 'relay12Delay')}
          />
          <TextField
            {...delay13}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay13Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay13.value) ||
              isFieldIvalid(elevatorsError, 'relay13Delay')
            }
            helperText={fieldError(elevatorsError, 'relay13Delay')}
          />
          <TextField
            {...delay14}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay14Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay14.value) ||
              isFieldIvalid(elevatorsError, 'relay14Delay')
            }
            helperText={fieldError(elevatorsError, 'relay14Delay')}
          />
          <TextField
            {...delay15}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay15Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay15.value) ||
              isFieldIvalid(elevatorsError, 'relay15Delay')
            }
            helperText={fieldError(elevatorsError, 'relay15Delay')}
          />
          <TextField
            {...delay16}
            fullWidth
            type="number"
            inputProps={{min: 1, max: 25}}
            label={`${configurations.relay16Name} delay:`}
            placeholder="1-25"
            error={
              isInvalid(delay16.value) ||
              isFieldIvalid(elevatorsError, 'relay16Delay')
            }
            helperText={fieldError(elevatorsError, 'relay16Delay')}
          />
        </Box>
      </Box>
    </form>
  );
};

export default ConfigurationsForm;
